"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PhoneShake = function PhoneShake(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M20.628 13.884a.488.488 0 01-.542-.42l-.584-5.316a.477.477 0 01.439-.519.488.488 0 01.542.42l.585 5.317a.478.478 0 01-.44.518zm-16.562 2.5a.488.488 0 01-.542-.42l-.585-5.316a.477.477 0 01.44-.519.488.488 0 01.541.42l.585 5.317a.477.477 0 01-.44.518zm1.35-7.81a.663.663 0 01.74.558l.845 7.493a.64.64 0 01-.599.69.663.663 0 01-.74-.56l-.844-7.492a.64.64 0 01.599-.69zm8.488-4.372a1.552 1.552 0 011.717 1.374l1.371 11.831a1.563 1.563 0 01-1.356 1.74l-5.533.658a1.552 1.552 0 01-1.717-1.375L7.015 6.6a1.563 1.563 0 011.356-1.74l5.533-.658zM9.507 17.35a.31.31 0 00.344.275l5.532-.658a.313.313 0 00.272-.348L14.5 6.656a.31.31 0 00-.343-.275l-5.533.658a.313.313 0 00-.271.348l1.154 9.963zm8.343-2.47l-.845-7.492a.64.64 0 01.6-.69.663.663 0 01.74.56l.844 7.492a.64.64 0 01-.6.69.663.663 0 01-.74-.56z"
  }));
};

var _default = (0, _react.forwardRef)(PhoneShake);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PhoneShake, "PhoneShake", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneShake.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/PhoneShake.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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